import * as actionTypes from './actionTypes';

const initialState = {
  bidSession: {
    activePreferenceOptionsIds: [],
  },
  error: { bidError: false, message: '' }
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_BID_SESSION_REQUEST:
      return { ...state, error: {}, isFetching: true };
    case actionTypes.FETCH_BID_SESSION_SUCCESS:
      return { ...state, bidSession: action.bidSession, error: {}, isFetching: false };
    case actionTypes.UPDATE_BID_SESSION_SUCCESS:
      return { ...state, bidSession: action.bidSession, error: {}, isFetching: false };
    case actionTypes.FETCH_BID_SESSION_FAILURE:
      return {
        ...state,
        error: {
          bidSession: true,
          messages: action.messages,
          isFetching: false
        }
      };
    case actionTypes.CLEAR_DATA:
      return initialState;

    default:
      return state;
  }
};

export { reducer as default };
